import React, {Component} from "react";
import {Button, Table} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "./ApiServices.css";
import {sortBy} from "../../../utils";
import {AddApiService} from "./AddApiService";
import EditField from "../../../common/EditField/EditField";
import ConfirmDialog from "../../../common/ConfirmDialog/ConfirmDialog";
import Permissions from "../../../authentication/Permissions";
import AuthorizationService from "../../../services/authorization-service";

class ApiServices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDeleteProductModalVisible: false,
            deleteItem: {}
        };
    }


    handleAddService = (newService) => {
        let services = this.props.product.services
        if (!services) services = []
        services.push(newService)
        this.props.editHandler(services)
    }

    renderApps() {
        if (!this.props.product.services) {
            return;
        }

        const sorted = sortBy(this.props.product.services, "displayName");
        return sorted.map((service, i) => {
            return (
                <tr key={`${service.displayName}-${i}`}>
                    <td className="width-50">
                        <EditField
                            value={service.displayName}
                            header={'Edit display name'}
                            title={'Update the display name'}
                            editHandler={this.editService}
                            contextItem={service}
                            canEdit={AuthorizationService.hasPermission(Permissions.product.edit) && this.props.product.isActive}
                        />
                    </td>
                    <td className={`${AuthorizationService.hasPermission(Permissions.product.edit) && this.props.product.isActive ? "width-45" : "width-50"}`}>
                        {service.serviceName}
                    </td>
                    <td className={`${AuthorizationService.hasPermission(Permissions.product.delete) && this.props.product.isActive ? "width-5" : ""} edit-btn`}>
                        {AuthorizationService.hasPermission(Permissions.product.delete) && (
                            <FontAwesomeIcon
                                className="fas delete-icon"
                                icon="times"
                                size="sm"
                                color="#59595B"
                                onClick={() => {
                                    this.setState({
                                        isDeleteItemModalVisible: true,
                                        deleteItem: service
                                    });
                                }}
                            />
                        )}
                    </td>
                </tr>
            );
        });
    }

    deleteItem = () => {
        let services = this.props.product.services.filter(s => s.serviceName !== this.state.deleteItem.serviceName);
        this.props.editHandler(services);
        this.reset();

    };

    reset = () => {
        this.setState({
            isDeleteItemModalVisible: false,

        })
    }


    editService = (displayName, service) => {
        let services = this.props.product.services;
        for (let i = 0; i < services.length; i++) {
            let item = services[i];
            if (item.serviceName === service.serviceName) {
                item.displayName = displayName;
            }
        }
        this.props.editHandler(services);

    };

    render() {
        return (
            <div className="api-product-services">
                {AuthorizationService.hasPermission(Permissions.product.edit) && this.props.product.isActive && (
                    <Button
                        onClick={() => this.setState({isAddServiceModalVisible: true})}
                        outline
                        color="success"
                        className="btn-add btn-add-service"
                    >
                        <FontAwesomeIcon className="sort-icon" icon="plus"/>
                        &nbsp;&nbsp;{"ADD SERVICE"}
                    </Button>
                )}

          <Table className="services-table">
            <thead>
            <tr>
                <th className="width-50">NAME</th>
                <th
                    className={`${AuthorizationService.hasPermission(Permissions.product.edit) && this.props.isActive ? "width-45" : "width-50"}`}
                >
                    PRODUCT ID
                </th>
                <th className={`${AuthorizationService.hasPermission(Permissions.product.edit) && this.props.isActive ? "width-5" : ""}`}>
                    {AuthorizationService.hasPermission(Permissions.product.edit) && this.props.isActive ? "EDIT" : ""}
                </th>
            </tr>
            </thead>
              <tbody>{this.renderApps()}</tbody>
          </Table>

                {/* Add service */}
                <AddApiService
                    cancelAction={() => this.setState({isAddServiceModalVisible: false})}
                    isAddServiceModalVisible={this.state.isAddServiceModalVisible}
                    addApiService={this.handleAddService}
                    product={this.props.product}
                />
                {/* Delete account product */}
                <ConfirmDialog
                    toggleState={this.state.isDeleteItemModalVisible}
                    cancelAction={() =>
                        this.setState({isDeleteItemModalVisible: false})
                    }
                    message={`Are you sure you want to remove ${
                        this.state.deleteItem.displayName
                    }?  This will only apply to accounts that have an Order Management Update`}
                    confirmAction={() => this.deleteItem()}
                    confirmActionName="Remove"
                    confirmClassName={"btn-warning"}
                    caption="Remove Service"
                    isLoading={this.state.isDialogLoading}
                />
            </div>
    );
  }
}

export default ApiServices;



// WEBPACK FOOTER //
// ./src/products/product-details/components/ApiServices.js